import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AppIconComponent } from '../../shared-components/icon/icon.component';
import { Constants } from '../../_constants/constants';

@Component({
  selector: 'app-static-page-layout',
  standalone: true,
  imports: [CommonModule, RouterModule, AppIconComponent],
  templateUrl: './static-page-layout.component.html',
  styleUrls: ['./static-page-layout.component.scss']
})
export class StaticPageLayoutComponent {
  @Input() pageTitle: string = '';

  aboutCiraNetUrl = '/about-ciranet';
  realManageUrl = Constants.realManageUrl;
  residentPortalUrl = '/';
  privacyPolicyUrl = '/privacy-policy';
  termsAndConditionsUrl = '/terms-and-conditions';
  customerSupportEmail = 'service@ciramail.com';
  contactPhone = '(855) 877-2472';
  contactAddress = '6111 W. Plano Parkway, Suite 1000, Plano, TX 75093';
}
